module.exports = __webpack_public_path__ + "img/img_work_injury_footer.7466a508.jpg";